export default __webpack_public_path__ + "media/75d6665160c294593f70260de854ed9240782857a1e87ef42d5ecefa410a3364.svg";